export default "__VITE_ASSET__19da6773__"